var exports = {
  "x": "ExpiryFootnote.module__footnote___ZFhNSz",
  "m": "ExpiryFootnote.module__inlineFootnote___ZFhNSz",
};

module.exports = exports;
